import { useNavigate } from 'react-router';
import { EppRedeemTerminateRequestType } from '../../generated/api/eppRedeemTerminateRequestType';
import { closeDialog, setDialogSubmitFailed, setDialogSubmitting } from '../../public/site/dialogStore.js';
import { addNotification } from '../../public/site/notificationStore.js';
import { paths } from '../constants/pathVariables';
import { postEppRedeemTerminate } from '../fetch';
import { t } from '../i18n';
import { useSearchParams } from './useSearchParams';
import type { DeliveryAddress } from '../../generated/api/deliveryAddress';
import type { PostEppRedeemTerminateRequest } from '../../generated/api/postEppRedeemTerminateRequest';
import type { Subscription } from '../../generated/api/subscription';

export const useEppTerminate = (sub: Subscription, isEoe: boolean): ((address: DeliveryAddress) => void) => {
  const navigate = useNavigate();
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return async (address: DeliveryAddress) => {
    try {
      const payload: PostEppRedeemTerminateRequest = {
        requestType: EppRedeemTerminateRequestType.TERMINATE,
        terminate: { address },
      };

      setDialogSubmitting(true);
      await postEppRedeemTerminate(sub.subscriptionId, payload, mdmId);
      addNotification(t.G4ZD('Your cancellation request was successfully sent'));
      closeDialog();
      navigate(isEoe ? paths.EMPLOYEE_DEVICES : paths.PS_DEVICES);
    } catch {
      setDialogSubmitFailed();
    }
  };
};
